"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunkQI6EW3G5cjs = require('./chunk-QI6EW3G5.cjs');


var _chunk4ZLWI3AAcjs = require('./chunk-4ZLWI3AA.cjs');


var _chunkZNXISNXVcjs = require('./chunk-ZNXISNXV.cjs');


var _chunkLRJOJOOScjs = require('./chunk-LRJOJOOS.cjs');

// src/contracts/dex/v1/index.ts
var DEX = {
  Router: _chunkQI6EW3G5cjs.RouterV1,
  Pool: _chunk4ZLWI3AAcjs.PoolV1,
  LpAccount: _chunkZNXISNXVcjs.LpAccountV1,
  pTON: _chunkLRJOJOOScjs.PtonV1
};



exports.DEX = DEX;
//# sourceMappingURL=chunk-OPOA3RRV.cjs.map